import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colorsPalette } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    wrapper: {
      width: '100%',
      padding: 16,
      borderRadius: 5,
      background: colorsPalette.violetAnalyticsCard,
      display: 'flex',
      alignItems: 'center',
    },
    image: {
      width: 28,
      height: 28,
      marginRight: 9,
    },
    text: {
      color: colorsPalette.gray,
      fontSize: 16,
      lineHeight: 1.5,
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
      },
    },
  });
});

export default useStyles;
